"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPRequestConfig = void 0;
var HTTPRequestConfig_1 = require("./HTTPRequestConfig");
Object.defineProperty(exports, "HTTPRequestConfig", { enumerable: true, get: function () { return HTTPRequestConfig_1.HTTPRequestConfig; } });
//# sourceMappingURL=index.js.map